import { API_URL } from "src/data/Api";
import { RoutePath } from "src/data/Routes";
import { NavDomain } from "./NavDomain";

export const customGroupsDomain: NavDomain = {
  matches: clsPath => clsPath === RoutePath.CUSTOM_GROUPS,

  pathUrl: itemSearch => API_URL.CUSTOM_GROUP_MENU + RoutePath.GET_PATH + itemSearch,
};
